export default "__VITE_ASSET__B1nSCgF0__"